import React from 'react';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import {useTranslation} from 'react-i18next';
import {TaskStateSingleVoyage} from "@containers/singleVoyage/tasks/helpers/executions";
import {classNames} from "@helpers/classNames";
import {sx} from './sx';

interface IProps {
    state: TaskStateSingleVoyage
    title?: string
    /** Rolled up into a summary row: no room for a glyph, so hue only. */
    small?: boolean
}

/**
 * The state of a task at a glance, for places where the mark carries no route
 * number and so can afford a glyph: done and not done differ by shape as well as
 * by hue, which red-green colour blindness cannot separate on its own.
 */
const TaskStateDotSingleVoyage = ({state, title, small}: IProps) => {

    const {t} = useTranslation()

    return (
        <Box
            component={'span'}
            sx={sx.stateDot}
            className={classNames(state, small && 'small')}
            title={title ?? t(`singleVoyage.taskStates.${state || 'planned'}`)}
        >
            {!small && state === 'done' && <CheckIcon sx={sx.stateDotIcon}/>}
            {!small && state === 'failed' && <RemoveIcon sx={sx.stateDotIcon}/>}
        </Box>
    );
};

export default TaskStateDotSingleVoyage;
